<app-form-field type="FILE"
                label="File"
                [settings]="settings.fieldsSettings.file"
                [value]="valuesForInput.file"
                (modelChange)="updateCurrentValue('file',$event)">
</app-form-field>
<app-form-field type="OPTION"
                label="Header present"
                [settings]="settings.fieldsSettings.headerPresent"
                [value]="valuesForInput.headerPresent"
                (modelChange)="updateCurrentValue('headerPresent',$event)">
</app-form-field>
<app-form-field type="OPTION"
                label="Separator"
                [settings]="settings.fieldsSettings.separator"
                [value]="valuesForInput.separator"
                (modelChange)="updateCurrentValue('separator',$event)">
</app-form-field>
<div class="layout horizontal space-between">
    <app-button-set align="left">
        <app-button [label]="'CANCEL'|translate" icon="arrow-left" (click)="cancel()" 
                    [disabled]="formSubmitting"></app-button>
    </app-button-set>
    <app-button-set align="right">
        <app-button [label]="'Upload'|translate" primary="true" icon="file-upload" [action]="submit.bind(this)" 
                    [disabled]="someErrors || formSubmitting"></app-button>
    </app-button-set>
</div>